import React from "react";
import styled from "styled-components";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText
} from "reactstrap";

const GuideCard = styled(Card)`
  height: 100%;
  box-shadow: none !important;
  background: transparent;
  overflow: visible;
  transition: transform 0.25s ease;

  &:hover {
    transform: translateY(-6px);
  }
`;

const GuideImageArea = styled.div`
  padding: 1rem 1rem 0;
`;

const GuideImageWrapper = styled.div`
  position: relative;
  width: 72%;
  max-width: 190px;
  aspect-ratio: 370 / 500;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 3rem;
  background-color: #f5f5f5;
`;

const GuideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
`;

const GuideBadge = styled.span`
  position: absolute;
  left: 50%;
  bottom: 0.75rem;
  transform: translateX(-50%);
  white-space: nowrap;
`;

const GuideBody = styled(CardBody)`
  display: flex;
  flex-direction: column;
`;

const GuideAccent = styled.div`
  width: 56px;
  height: 4px;
  border-radius: 999px;
  margin: 0 auto 1rem;
`;

const InfoLabel = styled.p`
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

const RichText = styled.div`
  p {
    margin-bottom: 0;
  }
`;

const Guides = ({ tour_guides = [] }) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <h2 className="text-center mb-5">Meet Our Guides </h2>
        </Col>
      </Row>
      <Row className="row-cols-1 row-cols-md-3 g-4 align-items-stretch">
        {tour_guides.map((guide) => (
          <Col key={guide.id} className="d-flex">
            <GuideCard className="w-100 rounded-5 shadow">
              {guide.cover_image && (
                <GuideImageArea>
                  <GuideImageWrapper>
                    <GuideImage src={guide.cover_image} alt={guide.name} />

                    {guide.years_experience !== null &&
                      guide.years_experience !== undefined && (
                        <GuideBadge className="badge rounded-pill text-bg-primary px-3 py-2 text-white">
                          {guide.name}
                        </GuideBadge>
                      )}
                  </GuideImageWrapper>
                </GuideImageArea>
              )}

              <GuideBody className="text-center px-4 py-4">
                <GuideAccent className="bg-primary" />

                {guide.role && (
                  <p className="text-primary fw-semibold small mb-3">
                    {guide.role}
                  </p>
                )}

                {guide.years_experience && (
                  <p className="fw-semibold small mb-3">
                    {guide.years_experience} years as a guide
                  </p>
                )}                

                {guide.favourite_monument && (
                  <div className="mb-3">
                    <InfoLabel className="text-primary fw-bold">
                      Favourite monument
                    </InfoLabel>

                    <p className="mb-0 fw-semibold">
                      {guide.favourite_monument}
                    </p>
                  </div>
                )}

                {guide.special_tip && (
                  <div>
                    <InfoLabel className="text-primary fw-bold">
                      Guide’s special tip
                    </InfoLabel>

                    <CardText tag="div" className="text-muted small mb-0">
                      <RichText
                        dangerouslySetInnerHTML={{
                          __html: guide.special_tip
                        }}
                      />
                    </CardText>
                  </div>
                )}
              </GuideBody>
            </GuideCard>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default Guides;
